
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.74 8.411c.173.191.26.417.26.678 0 .26-.087.477-.26.65a.883.883 0 01-.651.261.973.973 0 01-.678-.26L5 6.328 1.589 9.74a.941.941 0 01-1.303 0A.843.843 0 010 9.089c0-.26.095-.487.286-.678L3.672 5 .286 1.589A.926.926 0 010 .91c0-.26.095-.477.286-.65a.941.941 0 011.303 0L5 3.67 8.411.262A.973.973 0 019.09 0c.26 0 .477.087.65.26.174.174.261.391.261.651s-.087.487-.26.678L6.328 5 9.74 8.411z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    